module.exports = __webpack_public_path__ + "static/media/header-deco.ef76bfb7.svg";